// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgCrown = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="312 201 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.cw-1 {
  stroke: #fff;
  stroke-width: 0.25px;
}

.cw-1,
.cw-2,
.cw-3,
.cw-4 {
  stroke-miterlimit: 10;
}

.cw-4,
.cw-3 {
  fill: #fff;
}

.cw-5 {
  fill: #484747;
}

.cw-6 {
  fill: #f39ee5;
}

.cw-2,
.cw-3 {
  stroke: #000;
  stroke-width: 0.5px;
}

.cw-7 {
  fill: #ffa600;
}

.cw-8 {
  fill: var(--mascot-accent, #ff49a4);
  opacity: 0.4;
}
`}</style>
    </defs>
    <path
      className="cw-4"
      d="M527.32,311.6c0,35.48-17.52,66.86-44.39,85.97-.78.55-1.57,1.1-2.37,1.63-.98.66-1.97,1.31-2.98,1.93-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.25-.17-.51-.33-.76-.51-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="cw-8"
      d="M527.32,311.6c0,35.48-17.52,66.86-44.39,85.97-.78.55-1.57,1.1-2.37,1.63-.98.66-1.97,1.31-2.98,1.93-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.25-.17-.51-.33-.76-.51-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M499.76,359.52c.59-1.91-6.86-11.23-12.02-17.55-5.17-6.29-10.7-13.22-16.3-18.63-2.29-2.23-5.63-5.26-8.74-8.05-.68-.64-1.36-1.24-2-1.82-2.16-1.91-4.05-3.58-5.22-4.6-.78-.69-1.23-1.09-1.23-1.09,0,0-1.42,12.55-.72,18.12.02.18.04.33.08.49.77,5.53,2.99,12.92,7.17,17.95.73.87,1.46,1.66,2.24,2.4.46.44.94.88,1.43,1.29.45.4.98.8,1.53,1.22.71.57,1.43,1.09,2.17,1.64.11.06.22.15.33.24.29.21.56.41.86.62,1.62,1.14,3.26,2.3,4.93,3.64.25.18.48.37.71.57.28.24.54.46.79.68,5.36,4.65,12.91,11.95,14.86,11.26,1.96-.7,8.57-6.46,9.15-8.38Z" />
    <path d="M345.09,359.52c-.59-1.91,6.86-11.23,12.02-17.55,5.17-6.29,10.7-13.22,16.3-18.63,2.29-2.23,5.63-5.26,8.74-8.05.68-.64,1.36-1.24,2-1.82,2.16-1.91,4.05-3.58,5.22-4.6.78-.69,1.23-1.09,1.23-1.09,0,0,1.42,12.55.72,18.12-.02.18-.04.33-.08.49-.77,5.53-2.99,12.92-7.17,17.95-.73.87-1.46,1.66-2.24,2.4-.46.44-.94.88-1.43,1.29-.45.4-.98.8-1.53,1.22-.71.57-1.43,1.09-2.17,1.64-.11.06-.22.15-.33.24-.29.21-.56.41-.86.62-1.62,1.14-3.26,2.3-4.93,3.64-.25.18-.48.37-.71.57-.28.24-.54.46-.79.68-5.36,4.65-12.91,11.95-14.86,11.26-1.96-.7-8.57-6.46-9.15-8.38Z" />
    <path
      className="cw-4"
      d="M480.56,399.2c-.98.66-1.97,1.31-2.98,1.93-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-1.21-7.76-1.16-15.97.46-24.41,1.23-6.39,2.66-12.67,4.31-18.74.82-3.04,1.7-6.04,2.65-8.96.03-.12.07-.24.11-.36,4.75-14.78,10.96-27.82,18.89-37.36.05-.06.1-.12.16-.19,8.47-10.11,18.9-16.25,31.61-16.3h.16c12.5,0,22.98,5.66,31.54,15.24.33.37.67.75,1,1.14,7.82,9.2,13.99,21.76,18.57,36.24,1.18,3.71,2.24,7.54,3.2,11.48,1.41,5.74,2.6,11.7,3.58,17.81,1.31,8.22,1.25,16.2.08,23.74Z"
    />
    <path
      className="cw-2"
      d="M473.39,346.17c-9.08,18.58-28.63,31.43-51.28,31.43s-41.33-12.29-50.66-30.2c9.87-30.69,26.01-53.85,50.82-53.85s41.43,22,51.11,52.62Z"
    />
    <path
      className="cw-1"
      d="M458.43,301.55s.07-.01.07-.01c-4.89,15.4-15.39,25.44-18.7,36.48-4.43,14.7-5.77,29.83-7.02,31.2-2.52,2.71-17.61,2.71-20.96,0-1.68-1.37-1.17-15.71-6.18-28.78-5.7-14.8-6.51-17.01-13.83-28.36.01-.03.03-.07.07-.1-4.43-6.75-10.66-19.29-10.66-30.7,0-25.51,18.22-46.2,40.67-46.2s40.67,20.68,40.67,46.2c0,7.28-1.48,14.16-4.13,20.27Z"
    />
    <g>
      <path
        className="cw-6"
        d="M391.12,296.19c1.31-.54,2.19-1.08,2.72-2.38.53-1.31.27-2.3-.3-3.6-.57-1.29-1.97-2.49-3.17-3.01-1.2-.52-2.04-.7-3.33-.47-1.29.23-3.3,1.51-3.78,2.83-.48,1.32-.27,2.30.3,3.6.57,1.29,1.58,2.37,3.17,3.01,1.59.64,3.07.56,4.39.02Z"
      />
      <path
        className="cw-6"
        d="M452.39,296.14c-1.32-.51-2.21-1.04-2.77-2.33-.56-1.29-.31-2.3.23-3.6.54-1.31,1.92-2.53,3.11-3.07,1.19-.54,2.02-.74,3.32-.53,1.29.21,3.33,1.44,3.84,2.75.51,1.31.31,2.3-.23,3.6-.54,1.3-1.54,2.4-3.11,3.07-1.58.67-3.06.62-4.38.11Z"
      />
    </g>
    <path
      className="cw-5"
      d="M398.97,244.11c-4.07,3.35-7.9,7.47-10.64,12.27-3.56-1.71-7.24-4.06-7.77-6.54-.97-4.57,1.01-9.35,3.9-11.3,2.89-1.95,5.47-2.04,8.86-1.17,1.65.41,3.85,3.6,5.64,6.74Z"
    />
    <path
      className="cw-5"
      d="M463.56,249.83c-.53,2.48-4.71,4.83-8.27,6.54-2.74-4.8-5.9-8.05-9.97-11.4,1.79-3.13,3.83-7.2,5.48-7.61,3.39-.87,5.97-.78,8.86,1.17,2.89,1.95,4.87,6.72,3.9,11.3Z"
    />
    <path
      className="cw-3"
      d="M396.85,274.95c.09-5.46-4.29-9.96-9.77-10.04-5.48-.09-9.99,4.27-10.08,9.73-.09,5.46,4.29,9.96,9.77,10.04,5.48.09,9.99-4.27,10.08-9.73Z"
    />
    <path d="M387.88,283.09c4.48.69,8.28-3.09,7.6-7.55-.43-2.78-2.7-5.04-5.48-5.47-4.48-.69-8.28,3.09-7.6,7.55.43,2.78,2.7,5.04,5.48,5.47Z" />
    <path
      className="cw-3"
      d="M466.34,274.95c.09-5.46-4.29-9.96-9.77-10.04-5.48-.09-9.99,4.27-10.08,9.73-.09,5.46,4.29,9.96,9.77,10.04,5.48.09,10-4.27,10.08-9.73Z"
    />
    <path d="M453.34,282.74c4.48.69,8.28-3.10,7.6-7.56-.43-2.78-2.70-5.04-5.48-5.47-4.48-.69-8.28,3.10-7.6,7.56.43,2.78,2.70,5.04,5.48,5.47Z" />
    <polygon
      className="cw-4"
      points="441.17 218.38 441.17 240.64 402.62 240.64 402.62 217.85 413.91 229.15 422.16 220.9 430.4 229.15 441.17 218.38"
    />
    <polygon
      className="cw-7"
      points="441.17 218.38 441.17 240.64 402.62 240.64 402.62 217.85 413.91 229.15 422.16 220.9 430.4 229.15 441.17 218.38"
    />
  </svg>
);
export { SvgCrown };
